module.exports = __webpack_public_path__ + "static/img/menu2.e467c0d2.png";